import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import ScanTicketZ, { champsLus } from "../components/ScanTicketZ";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
// Accepte 1250,50 comme 1250.50 (clavier francais des telephones).
const nombre = (v) => (v === undefined || v === null || String(v).trim() === "" ? null : parseFloat(String(v).replace(/\s/g, "").replace(",", ".")));

export default function BilanBlockForm() {
  const { token } = useAuth();
  const [bilans, setBilans] = useState([]);
  const [ft, setFt] = useState(null);
  const [data, setData] = useState({});
  const [msg, setMsg] = useState("");
  const H = { headers: { Authorization: `Bearer ${token || localStorage.getItem("token")}` } };
  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API_URL}/kpis-performance/mes-bilans`, H);
        setBilans(r.data.bilans || []);
        setFt(r.data.food_truck_id);
      } catch (e) {}
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const setField = (eid, k, v) => setData((d) => ({ ...d, [eid]: { ...(d[eid] || {}), [k]: v } }));
  const valeur = (eid, k) => (data[eid] || {})[k] ?? "";
  const submit = async (eid) => {
    const b = data[eid] || {};
    const plats = nombre(b.nombre_plats);
    try {
      await axios.post(`${API_URL}/events/${eid}/bilan/${ft}`, {
        nombre_plats: plats === null ? null : Math.round(plats),
        ca_ht: nombre(b.ca_ht),
        ca_ttc: nombre(b.ca_ttc),
        commentaire: b.commentaire || "",
      }, H);
      setMsg("Bilan enregistre ! Deblocage en cours...");
      setTimeout(() => window.location.reload(), 900);
    } catch (e) {
      setMsg("Erreur: " + (e && e.response && e.response.data && e.response.data.detail ? e.response.data.detail : e.message));
    }
  };
  const champ = "border rounded-md h-10 px-3";
  return (
    <div className="space-y-4">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <h4 className="font-medium text-amber-800 mb-2">Bilans de prestation a remplir</h4>
        <p className="text-sm text-amber-700">Renseignez votre chiffre d'affaires pour chaque evenement ci-dessous pour retrouver l'acces.</p>
      </div>
      {bilans.map((b) => (
        <div key={b.event_id} className="bg-white border border-gray-200 rounded-lg p-4 space-y-2">
          <div className="font-medium">{b.titre} — {String(b.date).slice(0, 10)}{b.lieu ? " · " + b.lieu : ""}</div>
          <ScanTicketZ onLu={(r) => setData((d) => ({ ...d, [b.event_id]: { ...(d[b.event_id] || {}), ...champsLus(r) } }))} />
          <div className="grid grid-cols-2 gap-2">
            <input type="text" inputMode="numeric" placeholder="Nombre de plats" value={valeur(b.event_id, "nombre_plats")} onChange={(e) => setField(b.event_id, "nombre_plats", e.target.value)} className={champ} />
            <input type="text" inputMode="decimal" placeholder="CA HT (EUR)" value={valeur(b.event_id, "ca_ht")} onChange={(e) => setField(b.event_id, "ca_ht", e.target.value)} className={champ} />
            <input type="text" inputMode="decimal" placeholder="CA TTC (EUR)" value={valeur(b.event_id, "ca_ttc")} onChange={(e) => setField(b.event_id, "ca_ttc", e.target.value)} className={champ} />
            <input placeholder="Commentaire (optionnel)" value={valeur(b.event_id, "commentaire")} onChange={(e) => setField(b.event_id, "commentaire", e.target.value)} className={champ} />
          </div>
          <button onClick={() => submit(b.event_id)} className="bg-primary hover:bg-primary/90 text-white text-sm px-4 py-2 rounded-md">Valider ce bilan</button>
        </div>
      ))}
      {bilans.length === 0 && <p className="text-sm text-gray-500">Chargement / aucun bilan en attente.</p>}
      {msg && <p className="text-sm text-emerald-700 font-medium">{msg}</p>}
    </div>
  );
}
